var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function () {
    $.fn.findFirstParentOfType = function (filter) {
        var el = this.parent();
        while (el && el.length > 0 && !el.is(filter)) {
            el = el.parent();
        }
        return el;
    };
    var dateConverter = function (value) {
        if (value) {
            value = new Date(value);
            var m = value.getMonth() + 1;
            var d = value.getDate();
            value = [d < 10 ? ('0' + d) : d, m < 10 ? ('0' + m) : m, value.getFullYear()].join('-');
        }
        return value;
    };
    var dateConverterMomentJs = function (value) {
        if (value) {
            return moment(value).fromNow();
        }
        return value;
    };

    var isoDateRegexp = /\d{4}\-\d{2}\-\d{2}T\d{2}:\d{2}:\d{2}.*/;
    var linkRegExp = /\<a[^>]*>/;
    
    MDB.Charts.generateKendoTable = generateKendoTable;
    var dashFilters = $('.dashboard-filter');

    function generateKendoTable(data, widget, useMoment, kendoConfig) {
        var aliasses = {};
        if (widget && widget.data) {
            try {
                var tmp = widget.data('titles');
                if (tmp) {
                    tmp = JSON.parse(tmp);
                }
                if (tmp) {
                    aliasses = tmp;
                }
            } catch (e) {
                console.error("Error parsing widget aliasses");
                console.error(e.stack);
            }
        }
        var otherConfig = widget.data('config') || {};
        otherConfig = otherConfig.tableconfig;

        var row, table = $('<table />', {
            'class': 'table table-bordered table-striped dataTable'
        });

        if (data.length > 0) {
            var skipColumns = [];
            var filterColumns = [];

            row = $('<tr />', { 'class': 'h' });
            // detect timestamps and convert to a date object (format: "2014-12-03T00:00:00")
            var keys = Object.keys(data[0]),
                primaryKeys = [];
            var valueConverters = [];

            var tableLegend = MDB.Charts.parseTableLegend(kendoConfig,keys,aliasses);

            for (var i = 0; i < keys.length; i++) {
                if (dashFilters.length > 0) {
                    // TODO: we should do this based on the attributeId rather than the name
                    if (dashFilters.filter('[placeholder="' + keys[i] + '"]').length > 0) {
                        filterColumns[i] = true;
                    } else if (dashFilters.filter('[placeholder="' + aliasses[keys[i]] + '"]').length > 0) {
                        filterColumns[i] = true;
                    }
                }

                skipColumns[i] = otherConfig && otherConfig.hidden && otherConfig.hidden[keys[i]];
                primaryKeys[i] = otherConfig && otherConfig.primarykeys && otherConfig.primarykeys[keys[i]];
                if (skipColumns[i]) {
                    continue;
                }
                
                var tooltip = tableLegend.getTooltipText(i);
                if (tooltip) {
                    tooltip = $('<i />', { 'class': 'fa fa-info ml-1', 'data-toggle': 'tooltip', 'data-placement': 'bottom', 'data-original-title': tooltip });

                    tooltip.css({ 'font-size': tableLegend.getIconFontSize(i)});
                }

                
                $('<th />').text(tableLegend.getHeaderText(i)).data('name', keys[i])
                    .css(tableLegend.getStyle(i))
                    .append(tooltip)
                    .appendTo(row);

                // sample data
                var isDate = false;
                for (var x = 0; x < data.length && !isDate; x++) {
                    // we check for a date value using the first non-empty row
                    if (data[x][keys[i]] == '' || data[x][keys[i]] == null) {
                        continue;
                    }
                    isDate = isoDateRegexp.test(data[x][keys[i]] || '');
                    break;
                }

                if (isDate) {
                    valueConverters[i] = useMoment ? dateConverterMomentJs : dateConverter;
                }
            }
            table.append($('<thead />').append(row));
            var updateableFields = (otherConfig && otherConfig.updatable) || {};
            var boldFields = (otherConfig && otherConfig.boldFields) || {};

            data.forEach(function (value) {
                // clone the data
                var rowIsBold = false;
                var pk = {};
                row = $('<tr />', { 'class': 'r' });
                var i = 0, column, key;
                for (; i < keys.length; i++) {
                    key = keys[i];
                    if (primaryKeys[i] === true) {
                        pk[key] = value[key];
                    }
                    if (skipColumns[i] === true) {
                        continue;
                    }

                    column = value[key];
                    if (valueConverters[i]) {
                        column = valueConverters[i](column);
                    }

                    if (boldFields[key] === column) {
                        rowIsBold = true;
                    }
                    var td = $('<td />');
                    if (updateableFields[key] === 'checkbox') {
                        // render checkbox
                        var box = $('<input />', { type: 'checkbox', 'class': 'updatable' });
                        box.data('key', key);
                        if (column === '1' || column === 'true' || column === 'True') {
                            box.prop('checked', true);
                        }

                        td.append(box).appendTo(row);
                    } else {
                        var fn = 'text';
                        
                        if (kendoConfig && kendoConfig.linkifyUrls){
                            column = MDB.linkify(column);
                            fn = 'html';
                        } else if(linkRegExp.test(column)) {
                            fn = 'html';
                        }
                        
                        td[fn](column).appendTo(row);
                    }

                    if (filterColumns[i] === true) {
                        td.addClass('filter-cell').attr('title', 'Click to filter table by this value.');
                    }
                }
                row.data('primarykey', pk);

                if (rowIsBold) {
                    row.find('td').css('font-weight', 'bold');
                }
                table.append(row);
            });

        }

        table.on('change', 'input.updatable', function (e) {
            var me = $(this);
            var pk = me.findFirstParentOfType('tr').data('primarykey'),
                name = me.data('key');
            if (!pk) {
                return;
            }
            var data = {
                widgetId: widget.data('id')
            };
            data['val_' + me.data('key')] = me.prop('checked') ? 'true' : 'false';

            Object.keys(pk).forEach(function (key) {
                data['pk_' + key] = pk[key];
            });
            MDB.callApi({
                cache: false,
                type: 'POST',
                url: 'WidgetController/UpdateWidgetDataFromWidget',
                data: data
            }).fail(function (e) {
                console.log(arguments);
                console.warn("Error updating record: " + e.responseText);
            }).done(function (res) {

            });
        });

        table.on('click', '.filter-cell', function (e) {
            var self = $(this);
            var attributeName = self.closest('table').find('th').eq(self.index()).data('name');

            var targetFilter = dashFilters.filter('[placeholder="' + attributeName + '"],[placeholder="' + aliasses[attributeName] + '"]');
            if (targetFilter.length > 0) {
                var oldValue = targetFilter.val();
                var newValue = self.text();

                if (oldValue !== newValue) {
                    var filterId = targetFilter.data('shortId');
                    
                    //Either take an existing filter and overwrite it's values
                    //Or create our own instance
                    var filter = _.find(MDB.Charts.getArraySerializedFilters(), { attributeId: filterId });
                    filter = filter || {
                        filterId: filterId
                    };
                    
                    filter.values = newValue;
                    
                    //Overwrite the existing filter/add our newly created filter
                    MDB.Charts.setFilters(filter);
                    
                    
                    // var kWidget = MDB.KendoConfigBuilder.getKendoWidget(targetFilter);
                    // console.log(kWidget);
                    
                    
                    // console.log(targetFilter);
                    //
                    // targetFilter.trigger('change');
                    
                    // var kendoType = targetFilter.hasClass('dashboard-filter-multiple') ? 'kendoMultiSelect' : 'kendoDropDownList';
                    //
                    // var dropdownlist = targetFilter.data(kendoType);
                    // var ds = dropdownlist.dataSource;
                    //
                    // if (!ds.options.data){
                    //     targetFilter.one('mdb:data-loaded', function () {
                    //         dropdownlist.value(newValue);
                    //         dropdownlist.trigger('change');
                    //     });
                    //    
                    //     ds.read();
                    // }
                    // else{
                    //     dropdownlist.value(newValue);
                    //     dropdownlist.trigger('change');
                    // }
                }
            }
        });

        return table;
    };

    function tableImpl(widget, chart, data, metadata, useMoment) {
        // got data: [{"Column1":1,"Name":"Widget T1"}]
        //  convention: first column = value, 2nd column = 5
        if (!data || data.length == 0) {
            widget.find('.loading-box').hide();
            return;
        }

        setTimeout(function () {
            widget.useMoment = useMoment;
            MDB.Charts.renderers.tableGeneric(widget, chart, data, metadata, renderTable);
        }, 0);
    };

    function renderTable(widget, chart, data, metadata) {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        if (!metadata.KendoConfig || !metadata.KendoConfig.autoScaleHeight) {
            chart.css({
                'height': MDB.Charts.calculateKendoChartMaxHeight(widget) + 'px',
                'overflow-y': 'auto'
            });
        }

        if (!chart.hasClass('tablewidget')) {
            chart.addClass('tablewidget');
        }

        var kendoConfig = data.metadata.KendoConfig;
        if (kendoConfig && (kendoConfig.excel === true || (kendoConfig.excel && kendoConfig.excel.visible))) {
            var anchor = document.createElement('a');

            $(anchor).on('click', function(e){
                e.preventDefault();

                MDB.Charts.exportWidget(widget.data('id'));
            });

            anchor.href = '#';
            anchor.className = 'k-button k-button-icontext k-grid-excel';
            anchor.innerHTML = '<span class="k-icon k-i-excel"></span>' + MDB.loadResourceString('DataTable_Kendo_Action_Excel');

            chart.append(anchor);
        }
        
        
        if (kendoConfig && kendoConfig.bodyless === true) {
            return;
        }
        
        var tbl = generateKendoTable(data, widget, widget.useMoment, kendoConfig);
        chart.append(tbl);

        if (kendoConfig && kendoConfig.stickyHeader === true) {
            tbl.addClass('table-sticky-header');
            tbl.floatThead();
        }
    }


    MDB.Charts.renderers.table = function (widget, chart, data, metadata) {
        tableImpl(widget, chart, data, metadata, false);
    };

    MDB.Charts.renderers.tableWithMoment = function (widget, chart, data, metadata) {
        tableImpl(widget, chart, data, metadata, true);
    };

})();